import { onBeforeUpdate, shallowReadonly, shallowRef, useSlots } from 'vue'

export function useForeignSlotNames() {
  const slots = useSlots()
  const foreignSlotNames = shallowRef<string[]>([])
  function update() {
    foreignSlotNames.value = Object.entries(slots)
      .filter(([, slot]) => slot && slot.name === '')
      .map(([key]) => key)
  }
  // This is a hack, as slots are not reactive.
  onBeforeUpdate(update)
  return shallowReadonly(foreignSlotNames)
}
